import {
  Component, OnInit, ViewChild, OnDestroy,
  ElementRef, AfterViewInit, ChangeDetectorRef, HostListener
} from '@angular/core';
import {ROUTES} from './vertical-menu-routes.config';
import {HROUTES} from '../horizontal-menu/navigation-routes.config';

import {Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {customAnimations} from '../animations/custom-animations';
import {DeviceDetectorService} from 'ngx-device-detector';
import {ConfigService} from '../services/config.service';
import {Subscription} from 'rxjs';
import {LayoutService} from '../services/layout.service';
import {RouteInfo} from './vertical-menu.metadata';
import {PermissionManagerService} from '../services/permission-manager.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './vertical-menu.component.html',
  animations: customAnimations
})
export class VerticalMenuComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('toggleIcon') toggleIcon: ElementRef;
  public menuItems: any[];
  level: number = 0;
  logoUrl = 'assets/img/logo.png';
  public config: any = {};
  protected innerWidth: any;
  layoutSub: Subscription;
  configSub: Subscription;
  perfectScrollbarEnable = true;
  collapseSidebar = false;
  resizeTimeout;

  constructor(
    private router: Router,
    public translate: TranslateService,
    private layoutService: LayoutService,
    private configService: ConfigService,
    private cdr: ChangeDetectorRef,
    private cd: ChangeDetectorRef,
    private deviceService: DeviceDetectorService,
    private permissionManagerService: PermissionManagerService
  ) {
    this.config = this.configService.templateConf;
    this.innerWidth = window.innerWidth;
    this.isTouchDevice();
  }

  ngOnInit() {
    setTimeout(() => this.loadMenu(), 300);
  }

  loadMenu() {
    this.menuItems = ROUTES;
    const menuItems: RouteInfo[] = [];
    for (const menu of ROUTES) {
      if (menu.idcontro !== 0 && this.permissionManagerService.isGranted(menu.idcontro)) {
        const submen: RouteInfo[] = []
        for (const submenu of menu.submenu) {
          if (submenu.idcontro !== 0 && this.permissionManagerService.isGranted(submenu.idcontro)) {
            submen.push(submenu);
            this.cdr.detectChanges();
          }
        }
        if (menu.submenu.length === 0 || submen.length > 0) {
          menu.submenu = submen;
          menuItems.push(menu)
          this.cdr.detectChanges();
        }
      } else if (menu.idcontro === 0) {
        if (this.permissionManagerService.authenticationService.isUsuarioEspecial()) {
          menuItems.push(menu);
          this.cdr.detectChanges();
        }
      }
    }
    this.menuItems = menuItems;
    this.cdr.detectChanges();
  }

  ngAfterViewInit() {

    this.configSub = this.configService.templateConf$.subscribe((templateConf) => {
      if (templateConf) {
        this.config = templateConf;
      }
      this.loadLayout();
      this.cdr.markForCheck();

    });

    this.layoutSub = this.layoutService.overlaySidebarToggle$.subscribe(
      collapse => {
        if (this.config.layout.menuPosition === 'Side') {
          this.collapseSidebar = collapse;
        }
      });

  }


  @HostListener('window:resize', ['$event'])
  onWindowResize(event) {
    if (this.resizeTimeout) {
      clearTimeout(this.resizeTimeout);
    }
    this.resizeTimeout = setTimeout((() => {
      this.innerWidth = event.target.innerWidth;
      this.loadLayout();
    }).bind(this), 500);
  }


  loadLayout() {
    /*this.menuAfingana = [];

     if(this.idrol== 4) {

       this.menuItem = {};
       this.menuItem.path = "/page/factoraje";
       this.menuItem.title = "Factoraje";
       this.menuItem.icon = "ft-trending-up";
       this.menuItem.class = '';
       this.menuItem.badge = '';
       this.menuItem.badgeClass = '';
       this.menuItem.isExternalLink = false;
       this.menuItem.submenu = [];
       this.menuAfingana.push(this.menuItem);

     }

     if((this.idrol==2 || this.idrol==1) && this.idusuari!=66) {

       this.menuItem = {};
       this.menuItem.path = "/page/factoraje";
       this.menuItem.title = "Factoraje";
       this.menuItem.icon = "ft-trending-up";
       this.menuItem.class = '';
       this.menuItem.badge = '';
       this.menuItem.badgeClass = '';
       this.menuItem.isExternalLink = false;
       this.menuItem.submenu = [];
       this.menuAfingana.push(this.menuItem);
       if(this.idrol==2) {
         this.menuItem = {};
         this.menuItem.path = "/page/form-factoraje";
         this.menuItem.title = "Nueva Solicitud";
         this.menuItem.icon = "ft-plus";
         this.menuItem.class = '';
         this.menuItem.badge = '';
         this.menuItem.badgeClass = '';
         this.menuItem.isExternalLink = false;
         this.menuItem.submenu = [];
         this.menuAfingana.push(this.menuItem);
       }
     }

     if(this.idusuari==66 || this.idrol== 4 ){
       this.menuItem = {};
       this.menuItem.path = "/page/fideicomiso";
       this.menuItem.title = "Fideicomisos";
       this.menuItem.icon = "ft-map";
       //this.menuItem.class = 'has-sub';
       this.menuItem.class = '';
       this.menuItem.badge = '';
       this.menuItem.badgeClass = '';
       this.menuItem.isExternalLink = false;
       this.menuItem.submenu = []
       /*this.menuItem.submenu = [{ path: '/page/fideicomiso', title: 'Relación de Lotes', icon: 'ft-arrow-right submenu-icon', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [] },
         { path: '/page/fideicomisarios', title: 'Fideicomisarios', icon: 'ft-arrow-right submenu-icon', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: [] }];*/
    /* this.menuAfingana.push(this.menuItem);
   }


   this.menuItem = {};
   this.menuItem.path = "/page/clave";
   this.menuItem.title = "Cambio contraseña";
   this.menuItem.icon = "ft-hash";
   this.menuItem.class = '';
   this.menuItem.badge = '';
   this.menuItem.badgeClass = '';
   this.menuItem.isExternalLink = false;
   this.menuItem.submenu = [];
   this.menuAfingana.push(this.menuItem);

   */


    if (this.config.layout.menuPosition === 'Top') { // Horizontal Menu
      if (this.innerWidth < 1200) { // Screen size < 1200
        this.menuItems = HROUTES;
      }
    } else if (this.config.layout.menuPosition === 'Side') { // Vertical Menu{
     // this.menuItems = this.menuAfingana;
    }


    if (this.config.layout.sidebar.backgroundColor === 'white') {
      this.logoUrl = 'assets/img/logo-dark.png';
    } else {
      this.logoUrl = 'assets/img/logo.png';
    }

    if (this.config.layout.sidebar.collapsed) {
      this.collapseSidebar = true;
    } else {
      this.collapseSidebar = false;
    }

    this.cd.detectChanges();
  }

  toggleSidebar() {
    let conf = this.config;
    conf.layout.sidebar.collapsed = !this.config.layout.sidebar.collapsed;
    this.configService.applyTemplateConfigChange({layout: conf.layout});

    setTimeout(() => {
      this.fireRefreshEventOnWindow();
    }, 300);
  }

  fireRefreshEventOnWindow = function () {
    const evt = document.createEvent('HTMLEvents');
    evt.initEvent('resize', true, false);
    window.dispatchEvent(evt);
  };

  CloseSidebar() {
    this.layoutService.toggleSidebarSmallScreen(false);
  }

  isTouchDevice() {

    const isMobile = this.deviceService.isMobile();
    const isTablet = this.deviceService.isTablet();

    if (isMobile || isTablet) {
      this.perfectScrollbarEnable = false;
    } else {
      this.perfectScrollbarEnable = true;
    }

  }


  ngOnDestroy() {
    if (this.layoutSub) {
      this.layoutSub.unsubscribe();
    }
    if (this.configSub) {
      this.configSub.unsubscribe();
    }

  }

}
